import { CategoryTabedResponseDto } from '@tiendanube/common';
import { InterfaceNameValue } from '@tiendanube/components';
import { useNavegate } from 'App/hooks';
import { CancelAndSaveButtons, Stack } from 'commons/components';
import {
  ProductsOrderRemainingFiltersInterface,
  SectionProductItemInterface,
  SortBySelectType,
} from 'domains/Online';
import ProductsBySection from './components/ProductsBySection';

interface OrganizeProductsProps {
  categoryId: string;
  categories: CategoryTabedResponseDto[];
  sortBy: SortBySelectType;
  isSaving: boolean;
  isLoading: boolean;
  isLoadingRemainingProducts: boolean;
  isMaxUserSortProducts: boolean;
  products: SectionProductItemInterface[];
  productsStatus: string;
  productsCount: number;
  onActionMoved: (quantity: number) => void;
  onEnded: () => void;
  onChange: (data: InterfaceNameValue) => void;
  onChangeProducts: (products: SectionProductItemInterface[]) => void;
  onSubmit: () => void;
  onFetchRemainingProducts: (
    params: ProductsOrderRemainingFiltersInterface,
  ) => Promise<SectionProductItemInterface[]>;
}

function OrganizeProducts({
  categoryId,
  categories,
  sortBy,
  isSaving,
  isLoading,
  isLoadingRemainingProducts,
  isMaxUserSortProducts,
  products,
  productsStatus,
  productsCount,
  onActionMoved,
  onEnded,
  onChange,
  onChangeProducts,
  onSubmit,
  onFetchRemainingProducts,
}: Readonly<OrganizeProductsProps>) {
  const { goBack } = useNavegate();

  return (
    <Stack column align="stretch">
      <ProductsBySection
        categoryId={categoryId}
        categories={categories}
        sortBy={sortBy}
        products={products}
        productsStatus={productsStatus}
        productsCount={productsCount}
        isLoading={isLoading}
        isLoadingRemainingProducts={isLoadingRemainingProducts}
        isMaxUserSortProducts={isMaxUserSortProducts}
        onActionMoved={onActionMoved}
        onEnded={onEnded}
        onChange={onChange}
        onChangeProducts={onChangeProducts}
        onFetchRemainingProducts={onFetchRemainingProducts}
      />
      <CancelAndSaveButtons
        isDisabled={isSaving}
        isLoading={isSaving}
        onSave={onSubmit}
        onCancel={goBack}
      />
      <Stack.Item />
    </Stack>
  );
}

export default OrganizeProducts;
